import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-brand-background text-white py-6">
      <div className="container mx-auto">
        <p className="text-center text-sm font-silkscreen">
          &copy; {new Date().getFullYear()} MTLX. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
